// used for live-previewing all RC content
export const data: any = {
  NEXT_PUBLIC_SITE_MACHINE_NAME: "preview",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "citn2sn5tdjr",
  BYPASS_CONSENT_CHECK: true
}
